import React from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'

import { BASEMAPS, SIDEBAR_VIEWS } from '../../../lib/constants'
import CrosshairIcon from '../../../assets/svg/CrosshairIcon2'
import styles from './CrosshairWidget.module.scss'

function CrosshairWidget(props) {
  const esriClassNames = 'esri-widget esri-component'
  const ghClassNames = styles.crosshairContainerCenter
  return props.showCrosshair ? (
    <div className={`${esriClassNames} ${ghClassNames}`}>
      <CrosshairIcon width={42} height={42} />
    </div>
  ) : null
}

CrosshairWidget.propTypes = {
  showCrosshair: PropTypes.bool
}

// export default CrosshairWidget

export default connect(model => {
  const { sidebarView } = model.app
  const { basemapMode } = model.map
  const isHistoricalView = sidebarView.view === SIDEBAR_VIEWS.HistoricalImagery
  const isTopographicBasemap = basemapMode === BASEMAPS.Topographic
  const showCrosshair = isHistoricalView && !isTopographicBasemap
  return {
    showCrosshair
  }
})(CrosshairWidget)
